// extracted by mini-css-extract-plugin
export default {"organisation":"organisation_organisation__O6dYq","organisationWelCard":"organisation_organisationWelCard__SDJul","organisationTableCard":"organisation_organisationTableCard__+ZWcQ"};